// Template: resources/views/account/billing.blade.php

import Invoices from './Invoices';
import ApiClient from '../support/ApiClient';
import debounce from 'lodash.debounce';

export default {

    name: "Billing",

    components: { Invoices },

    data() {
        return {
            showNewCardModal: false,
            savedCards: null,
            defaultSavedCard: {},
            showUpdateCardModal: false,
            savedCardToUpdate: {},
            showDeleteCardModal: false,
            savedCardToDelete: {},
            vatId: '',
            vatIdStatus: '',
            saveButton: null,
            api: {}
        }
    },

    created() {
        this.api = new ApiClient('store');
        this.getCards();
    },

    mounted() {
        this.saveButton = document.querySelector('[form="billing-form"]');
        this.vatId = this.$refs['company_vat_id'].dataset.initialValue;
    },

    watch: {
        vatId(vatId) {
            this.vatId = vatId.replace(/\s/g, '').toUpperCase();
            this.vatIdStatus = '';
            this.requestVatId();
        }
    },

    methods: {
        beforeLeave(el) {
            const { marginLeft, marginTop, width, height } = window.getComputedStyle(el)
            el.style.left = `${el.offsetLeft - parseFloat(marginLeft, 10)}px`;
            el.style.top = `${el.offsetTop - parseFloat(marginTop, 10)}px`;
            el.style.width = width;
            el.style.height = height;
        },

        getCards() {
            this.api.get('cards', data => {
                this.savedCards = data;
            });
        },

        openNewCardModal() {
            this.showNewCardModal = true;
        },

        closeNewCardModal() {
            this.showNewCardModal = false;
        },

        addNewCard() {
            // TODO: card processing

            // Response card
            var dummyCard = {
                token: this.savedCards.length + 1,
                type: ["visa", "mastercard", "maestro", "jcb", "discover"][Math.floor(Math.random() * 5)],
                last4: Math.floor(1000 + Math.random() * 9000),
                expiration: {
                    month: '11',
                    year: '2011'
                }
            };

            // All done, close modal
            this.closeNewCardModal();

            // Update UI
            this.addToSavedCards(dummyCard);
        },

        addToSavedCards(card) {
            this.savedCards.push(card);
        },

        removeFromSavedCards(card) {
            this.savedCards.splice(this.savedCards.indexOf(card), 1);
        },

        openUpdateCardModal(card) {
            this.savedCardToUpdate = card;
            this.showUpdateCardModal = true;
        },

        closeUpdateCardModal() {
            this.savedCardToUpdate = {};
            this.showUpdateCardModal = false;
        },

        updateCard(card) {
            // TODO: card processing

            // Response card
            var dummyCard = {
                token: card.token,
                type: ["visa", "mastercard", "maestro", "jcb", "discover"][Math.floor(Math.random() * 5)],
                last4: Math.floor(1000 + Math.random() * 9000),
                expiration: {
                    month: '11',
                    year: '2011'
                }
            };

            // All done, close modal
            this.closeUpdateCardModal();

            // Update UI
            this.savedCards[this.savedCards.indexOf(card)] = dummyCard;
            if (this.defaultSavedCard.id == card.id) this.defaultSavedCard = dummyCard;
        },

        openDeleteCardModal(card) {
            this.savedCardToDelete = card;
            this.showDeleteCardModal = true;
        },

        closeDeleteCardModal() {
            this.savedCardToDelete = {};
            this.showDeleteCardModal = false;
        },

        deleteCard(card) {
            this.api.delete(`card?token=${card.token}`, () => {
                // All done, close modal
                this.closeDeleteCardModal();

                // Update UI
                this.removeFromSavedCards(card);

                this.$bus.$emit('toast', { message: this.$t__('Card deleted'), type: 'success' });
            });
        },

        requestVatId: debounce(function () {
            if (this.vatId === '') {
                this.vatIdStatus = '';
                this.saveButton.disabled = false;
                return;
            }

            this.vatIdStatus = 'loading';
            this.saveButton.disabled = true;

            if (!this.vatId.match(/[a-zA-Z]{2}\d+/)) {
                this.vatIdStatus = 'error';
            } else {
                this.api.get(`vat-validity?id=${this.vatId}`, validity => {
                    this.vatIdStatus = validity ? 'ok' : 'error';
                    this.saveButton.disabled = !validity;
                }, () => {
                    this.saveButton.disabled = true;
                    this.vatIdStatus = 'fail';
                });
            }
        }, 1000)
    }
};
